import { LogInForm } from "@/components/auth";
import { useLoginRouting } from "@/hooks";

export const LoginPage = () => {
  useLoginRouting();

  return (
    <div className="flex-row flex-grow justify-center my-auto">
      <div className="flex flex-row justify-center">
        <div className="border-2 shadow-lg p-8 bg-white rounded-xl">
          Welcome! Login Below to continue.
          <div className="mt-4">
            <LogInForm />
          </div>
        </div>
      </div>
    </div>
  );
};
